import { Link } from 'react-router-dom';
import './not-found.css';

export function NotFoundPage() {
  return (
    <main className="not-found">
      <p>404 · LOST GAME</p>
      <h1>这只盒子里<br />没有游戏。</h1>
      <Link to="/">回到 gameplanet 小游戏收藏</Link>
    </main>
  );
}
